import { render, staticRenderFns } from "./BootstrapToggle.vue?vue&type=template&id=4cf8e74d"
import script from "./BootstrapToggle.vue?vue&type=script&lang=js"
export * from "./BootstrapToggle.vue?vue&type=script&lang=js"
import style0 from "./BootstrapToggle.vue?vue&type=style&index=0&id=4cf8e74d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports